(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
/**
 * hg-faq accordion — aria-expanded sync
 * The <details> element handles open/close natively.
 * This script syncs aria-expanded on <summary> for assistive technologies.
 */
(function () {
  'use strict';

  function syncAriaExpanded(details) {
    var summary = details.querySelector('.hg-faq__summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function initFaqSection(section) {
    var detailsEls = section.querySelectorAll('.hg-faq__details');

    detailsEls.forEach(function (details) {
      // Set initial state
      syncAriaExpanded(details);

      // Update on toggle
      details.addEventListener('toggle', function () {
        syncAriaExpanded(details);
      });
    });
  }

  function boot() {
    var faqSections = document.querySelectorAll('.hg-faq');
    faqSections.forEach(initFaqSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-box-hero"] && !Shopify.designMode) return;
  try {
    
/**
 * hg-product-hero — thumbnail gallery switcher
 * Clicking a thumbnail swaps the main image src.
 */
(function () {
  'use strict';

  function initProductHero(section) {
    var mainWrap = section.querySelector('.hg-product-hero__main-image-wrap');
    var mainImg  = mainWrap ? mainWrap.querySelector('.hg-product-hero__main-image') : null;
    var thumbBtns = Array.from(section.querySelectorAll('.hg-product-hero__thumb-btn'));

    if (!mainImg || thumbBtns.length === 0) return;

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var thumbImg = btn.querySelector('.hg-product-hero__thumb');
        if (!thumbImg) return;

        // Swap main image src — use srcset/sizes for responsive swap
        var newSrc = thumbImg.src.replace(/width=\d+/, 'width=900');
        mainImg.src = newSrc;
        mainImg.alt = thumbImg.alt;

        // Update active state
        thumbBtns.forEach(function (b) {
          b.classList.remove('hg-product-hero__thumb-btn--active');
        });
        btn.classList.add('hg-product-hero__thumb-btn--active');
      });
    });
  }

  function initVariantPicker(section) {
    var variantBtns = Array.from(section.querySelectorAll('.hg-product-hero__variant-btn'));
    if (variantBtns.length === 0) return;

    var variantIdInput = section.querySelector('input[name="id"]');
    var priceEl = section.querySelector('.hg-product-hero__price');
    var addToCartBtn = section.querySelector('.hg-product-hero__add-to-cart');

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;

        var variantId = btn.dataset.variantId;
        var available = btn.dataset.variantAvailable === 'true';
        var price = parseInt(btn.dataset.variantPrice, 10);

        // Update hidden input (read by product-form-component)
        if (variantIdInput) variantIdInput.value = variantId;

        // Update active state
        variantBtns.forEach(function (b) {
          b.classList.remove('hg-product-hero__variant-btn--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('hg-product-hero__variant-btn--active');
        btn.setAttribute('aria-pressed', 'true');

        // Update price display
        if (priceEl && price) {
          var formatted = (price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          var priceSpan = priceEl.querySelector('.hg-product-hero__price-current, .hg-product-hero__price-sale');
          if (priceSpan) priceSpan.textContent = formatted;
        }

        // Update add-to-cart button state
        if (addToCartBtn) {
          if (available) {
            addToCartBtn.disabled = false;
            addToCartBtn.removeAttribute('aria-disabled');
            addToCartBtn.textContent = 'Add to Cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.setAttribute('aria-disabled', 'true');
            addToCartBtn.textContent = 'Sold Out';
          }
        }
      });
    });
  }

  function boot() {
    var heroSections = document.querySelectorAll('.hg-product-hero');
    heroSections.forEach(initProductHero);
    heroSections.forEach(initVariantPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
/**
 * hg-testimonials carousel
 * Progressive enhancement — grid layout works without JS.
 * Only activates for sections with layout === 'carousel'.
 */
(function () {
  'use strict';

  /**
   * Initialise a single carousel section.
   * @param {HTMLElement} section
   */
  function initCarousel(section) {
    var track = section.querySelector('.hg-testimonials__track');
    if (!track) return;

    var cards      = Array.from(track.querySelectorAll('.hg-testimonials__card'));
    var dots       = Array.from(section.querySelectorAll('.hg-testimonials__dot'));
    var btnPrev    = section.querySelector('.hg-testimonials__nav-btn--prev');
    var btnNext    = section.querySelector('.hg-testimonials__nav-btn--next');
    var current    = 0;
    var perView    = getPerView();

    if (cards.length === 0) return;

    function getPerView() {
      return window.innerWidth >= 768 ? 2 : 1;
    }

    function maxIndex() {
      return Math.max(0, cards.length - perView);
    }

    function goTo(index) {
      current = Math.min(Math.max(index, 0), maxIndex());

      var cardWidth     = cards[0].getBoundingClientRect().width;
      var gapPx         = parseInt(window.getComputedStyle(track).columnGap, 10) || 24;
      var translateX    = current * (cardWidth + gapPx);
      track.style.transform = 'translateX(-' + translateX + 'px)';

      /* Update dots */
      dots.forEach(function (dot, i) {
        dot.classList.toggle('hg-testimonials__dot--active', i === current);
      });

      /* Update button states */
      if (btnPrev) btnPrev.disabled = current === 0;
      if (btnNext) btnNext.disabled = current >= maxIndex();
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function () { goTo(current - 1); });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () { goTo(current + 1); });
    }

    /* Touch / swipe support */
    var touchStartX = null;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var delta = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(delta) > 40) {
        goTo(delta > 0 ? current + 1 : current - 1);
      }
      touchStartX = null;
    }, { passive: true });

    /* Recalculate on resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        perView = getPerView();
        goTo(current);
      }, 150);
    });

    /* Initial state */
    goTo(0);
  }

  /* Boot all carousel sections on the page */
  function boot() {
    var carousels = document.querySelectorAll('.hg-testimonials--carousel');
    carousels.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
